import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Redirect } from 'react-router-dom';
import ReferralCode from './ReferralCode';
import ReferredUserList from './ReferredUserList';
import SmsInvite from './SmsInvite';
import Loading from '../shared/Loading';
import Terms from './Terms';

import './index.css';

const Referral = () => (
  <Query query={REF_CODE}>
    {({ data, loading, error }) => {
      if (loading) return <Loading size="3x" />;
      if (['blacklisted'].includes(data.currentUser.status)) return <Redirect to="/profile" />;
      return (
        <div className="container referral__container">
          <h2>Invite your friends to join Autzu</h2>
          <h5>Share your code with a friend. After your friend drives 20 hours, you both get $50!</h5>
          <SmsInvite />

          <ReferralCode referralUrl={data.currentUser.referralUrl} />
          <ReferredUserList />
          <Terms />
        </div>
      );
    }}
  </Query>
);

export default Referral;

const REF_CODE = gql`
  {
    currentUser {
      id
      referralUrl
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Referral/index.js